// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.pgc-content .author .flex1 {
  width: calc(46 / var(--base-width) * 100vw);
  height: calc(46 / var(--base-width) * 100vw);
}
.pgc-content .author .flex2 .title {
  display: inline-block;
}
.pgc-content .author .flex2 img {
  width: 24px;
  height: 24px;
  display: inline-block;
  margin-left: 6px;
}
.pgc-content .author .flex3 {
  padding: 0;
  justify-content: flex-end;
  display: flex;
}
.pgc-content .author .flex3 ion-button {
  --background: var(--ion-color-primary-tint);
  margin: 2px 0 0 0;
}
.pgc-content .content {
  padding: 10px 0px 10px 0px;
}
.pgc-content .img_container {
  width: calc(323 / var(--base-width) * 100vw);
  height: calc(190 / var(--base-width) * 100vw);
  margin: auto;
}
.pgc-content .img_container .myImage {
  width: 100%;
  height: 100%;
  background-position: center !important;
  background-size: cover !important;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 30px;
}

/* 關注 */
.non-follow-btn {
  --background: var(--ion-color-primary-tint);
  width: calc(68 * var(--width-ratio));
  height: calc(24 * var(--width-ratio));
  margin: unset;
  --padding-end: unset;
  --padding-start: unset;
}

/* 已關注 */
.follow-btn {
  --background: white !important;
  --border-color: var(--ion-color-medium);
  --color: var(--ion-color-medium);
  --border-style: solid;
  --border-width: 1px;
  clear: both;
  width: calc(84 * var(--width-ratio));
  height: calc(24 * var(--width-ratio));
  margin: unset;
  --padding-end: unset;
  --padding-start: unset;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/expert-post-list/expert-post-list.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAMZ;EACE,2CAAA;EACA,4CAAA;AAJN;AASM;EACE,qBAAA;AAPR;AASM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;AAPR;AAWI;EACE,UAAA;EACA,yBAAA;EACA,aAAA;AATN;AAWM;EACE,2CAAA;EACA,iBAAA;AATR;AAcE;EACE,0BAAA;AAZJ;AAeE;EACE,4CAAA;EACA,6CAAA;EACA,YAAA;AAbJ;AAeI;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,iCAAA;EAIA,4BAAA;EACA,6BAAA;EACA,gCAAA;EACA,+BAAA;AAhBN;;AAqBA,OAAA;AACA;EACE,2CAAA;EACA,oCAAA;EACA,qCAAA;EAIA,aAAA;EACA,oBAAA;EACA,sBAAA;AArBF;;AAwBA,QAAA;AACA;EACE,8BAAA;EACA,uCAAA;EACA,gCAAA;EACA,qBAAA;EACA,mBAAA;EAGA,WAAA;EACA,oCAAA;EACA,qCAAA;EAEA,aAAA;EACA,oBAAA;EACA,sBAAA;AAxBF","sourcesContent":[".pgc-content {\n  // margin-top: 32px;\n\n  .author {\n    //display: flex;\n\n    .flex1 {\n      width: calc(46 / var(--base-width) * 100vw);\n      height: calc(46 / var(--base-width) * 100vw);\n    }\n\n    .flex2 {\n      // margin-left: 10px;\n      .title {\n        display: inline-block;\n      }\n      img {\n        width: 24px;\n        height: 24px;\n        display: inline-block;\n        margin-left: 6px;\n      }\n    }\n\n    .flex3 {\n      padding: 0;\n      justify-content: flex-end;\n      display: flex;\n\n      ion-button {\n        --background: var(--ion-color-primary-tint);\n        margin: 2px 0 0 0;\n      }\n    }\n  }\n\n  .content {\n    padding: 10px 0px 10px 0px;\n  }\n\n  .img_container {\n    width: calc(323 / var(--base-width) * 100vw);\n    height: calc(190 / var(--base-width) * 100vw);\n    margin: auto;\n\n    .myImage {\n      width: 100%;\n      height: 100%;\n      background-position: center !important;\n      background-size: cover !important;\n      // content: url(\"../../../assets/img/sample.png\");\n      // background-image: url(\"/assets/img/sample.png\");\n\n      border-top-left-radius: 30px;\n      border-top-right-radius: 30px;\n      border-bottom-right-radius: 10px;\n      border-bottom-left-radius: 30px;\n    }\n  }\n}\n\n/* 關注 */\n.non-follow-btn {\n  --background: var(--ion-color-primary-tint);\n  width: calc(68 * var(--width-ratio));\n  height: calc(24 * var(--width-ratio));\n\n  // margin-top: calc(2 * var(--width-ratio));\n  // margin-right: 26px;\n  margin: unset;\n  --padding-end: unset;\n  --padding-start: unset;\n}\n\n/* 已關注 */\n.follow-btn {\n  --background: white !important;\n  --border-color: var(--ion-color-medium);\n  --color: var(--ion-color-medium);\n  --border-style: solid;\n  --border-width: 1px;\n  // margin: 2px 0 0 0;\n  // margin-right: 26px;\n  clear: both;\n  width: calc(84 * var(--width-ratio));\n  height: calc(24 * var(--width-ratio));\n\n  margin: unset;\n  --padding-end: unset;\n  --padding-start: unset;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
